/**
 * 첨부 사진 정렬 — `photoSeq`(각 사진 테이블의 PHOTO_SEQ) 오름차순.
 *
 * 등록 시 FE가 0..n 으로 부여해 보낸 순번이고, 조회 화면은 그 순서대로 보여야 한다.
 * 서버 정렬(§3.2 는 photoSeq 오름차순 반환이 계약)을 신뢰하되, 화면에서도 한 번 더 보장한다.
 *
 * `photoSeq` 가 아직 응답에 없는 API(§2.1·§2.2·§2.14·§3.10 — BE 추가 예정)를 위해,
 * 값이 없는 항목은 원래 순서를 유지한다(안정 정렬 + 미보유 항목은 뒤로 밀지 않음).
 */
export function byPhotoSeq<T extends { photoSeq?: number | null }>(photos: T[]): T[] {
  return photos
    .map((p, i) => ({ p, i }))
    .sort((a, b) => {
      const sa = a.p.photoSeq;
      const sb = b.p.photoSeq;
      // 한쪽이라도 순번이 없으면 비교하지 않고 원래 순서를 유지한다.
      if (sa == null || sb == null) return a.i - b.i;
      return sa !== sb ? sa - sb : a.i - b.i;
    })
    .map(({ p }) => p);
}
